export default {
  navbar: {
    home: 'Главная',
    jobs: 'Вакансии',
    companies: 'Компании',
    about: 'О нас',
    customerService: 'Поддержка',
    signIn: 'Войти',
    register: 'Регистрация'
  },
  customerService: {
    title: 'Связаться с поддержкой',
    subtitle: 'Наша профессиональная команда поддержки всегда здесь для вас, 24/7 онлайн, чтобы ответить на ваши вопросы.',
    onlineService: 'Онлайн-сервис',
    serviceDescription: 'Наша профессиональная команда поддержки всегда здесь для вас, 24/7',
    startChat: 'Начать онлайн-чат',
    responseTime: 'Среднее время ответа: 30 секунд',
    instantResponse: 'Мгновенный ответ',
    instantResponseDesc: 'Наша команда поддержки онлайн 24/7, среднее время ответа менее 2 минут',
    professionalTeam: 'Профессиональная команда',
    professionalTeamDesc: 'Строго обученный персонал поддержки, знакомый со всеми бизнес-процессами',
    securityPrivacy: 'Безопасность и конфиденциальность',
    securityPrivacyDesc: 'Вся ваша информация зашифрована для обеспечения абсолютной безопасности',
    serviceOnline: 'Сервис онлайн',
    seniorConsultant: 'Старший клиентский консультант'
  },
  home: {
    heroTitle: 'Найдите работу мечты в киноиндустрии',
    heroSubtitle: 'Свяжитесь с лучшими кинотеатрами и развлекательными компаниями. Начните свое путешествие в захватывающем мире кино сегодня.',
    popularCategories: 'Популярные категории вакансий',
    categoriesDescription: 'Изучите возможности в различных сферах кино и развлечений',
    featuredJobOpportunities: 'Рекомендуемые вакансии',
    discoverLatestOpenings: 'Узнайте о последних вакансиях в лучших кинотеатрах',
    openPositions: 'открытых вакансий',
    quickApply: 'Быстрый отклик',
    whyChooseUs: 'Почему выбирают нас',
    joinLargestNetwork: 'Присоединитесь к крупнейшей сети кинопрофессионалов',
    categories: {
      theaterOperations: {
        title: 'Управление кинотеатром',
        description: 'Управляйте повседневной работой кинотеатра, обеспечивая плавные показы'
      },
      boxOfficeManagement: {
        title: 'Управление кассой',
        description: 'Обрабатывайте продажу билетов и обслуживание клиентов в кассе'
      },
      cinemaTechnology: {
        title: 'Технологии кинотеатра',
        description: 'Обслуживайте и управляйте передовым оборудованием и системами кинотеатра'
      },
      customerService: {
        title: 'Обслуживание клиентов',
        description: 'Предоставляйте превосходное обслуживание зрителям кинотеатра'
      },
      foodBeverage: {
        title: 'Продукты питания',
        description: 'Управляйте работой закусочной и обслуживанием в буфете'
      },
      marketingPromotions: {
        title: 'Маркетинг и продвижение',
        description: 'Создавайте и реализуйте маркетинговые стратегии для кинотеатров'
      }
    },
    featuredJobs: {
      theaterManager: {
        title: 'Менеджер кинотеатра',
        company: 'AMC Theatres',
        location: 'Нью-Йорк, NY',
        type: 'Полная занятость',
        salary: '$65K - $85K',
        benefit: 'Преимущества'
      },
      digitalProjectionist: {
        title: 'Цифровой киномеханик',
        company: 'Regal Cinemas',
        location: 'Лос-Анджелес, CA',
        type: 'Полная занятость',
        salary: '$45K - $60K',
        benefit: 'Обучение'
      },
      marketingCoordinator: {
        title: 'Координатор маркетинга',
        company: 'Cinemark',
        location: 'Чикаго, IL',
        type: 'Полная занятость',
        salary: '$50K - $65K',
        benefit: 'Удаленная работа'
      }
    },
    features: {
      largeIndustryNetwork: {
        title: 'Большая индустрийная сеть',
        description: 'Свяжитесь с более чем 2500+ кинотеатрами и развлекательными компаниями по всему миру',
        stat: '15,000+ активных пользователей'
      },
      verifiedEmployers: {
        title: 'Проверенные работодатели',
        description: 'Все работодатели тщательно проверяются для обеспечения реальных возможностей',
        stat: '100% проверенные компании'
      },
      careerGrowth: {
        title: 'Карьерный рост',
        description: 'Доступ к учебным ресурсам и возможностям повышения',
        stat: '89% успешности'
      }
    }
  },
  jobs: {
    heroTitle: 'Присоединяйтесь к нашей киносемье',
    heroSubtitle: 'Станьте частью магии, которая оживляет истории. Мы ищем увлеченных людей, чтобы присоединиться к нашей растущей команде.',
    viewPositions: 'Просмотреть открытые вакансии',
    currentOpenings: 'Текущие вакансии',
    department: 'Отдел',
    location: 'Местонахождение',
    applyNow: 'Применить сейчас',
    whyJoinUs: 'Почему стоит присоединиться',
    ourCulture: 'Наша культура',
    applicationProcess: 'Процесс подачи заявки',
    startYourJourney: 'Начните свое путешествие',
    benefits: {
      freeMovieAccess: {
        title: 'Бесплатные фильмы',
        description: 'Наслаждайтесь неограниченным количеством бесплатных фильмов для вас и вашей семьи.'
      },
      careerGrowth: {
        title: 'Карьерный рост',
        description: 'Комплексное обучение и четкие пути карьерного роста.'
      },
      flexibleSchedule: {
        title: 'Гибкий график',
        description: 'Гибкие варианты расписания для баланса работы и жизни.'
      }
    },
    jobList: [
      {
        title: 'Менеджер операций кинотеатра',
        location: 'Нью-Йорк, NY',
        type: 'Полная занятость',
        description: 'Руководите повседневной работой кинотеатра, гарантируя, что наш флагманский кинотеатр обеспечивает исключительный сервис.'
      },
      {
        title: 'Старший киномеханик',
        location: 'Лос-Анджелес, CA',
        type: 'Полная занятость',
        description: 'Управляйте и обслуживайте цифровые проекционные системы для обеспечения оптимального просмотра.'
      },
      {
        title: 'Руководитель команды буфета',
        location: 'Чикаго, IL',
        type: 'Полная занятость',
        description: 'Управляйте работой буфета и руководите профессиональной командой обслуживания.'
      },
      {
        title: 'Специалист по обслуживанию гостей',
        location: 'Майами, FL',
        type: 'Частичная занятость',
        description: 'Предоставляйте исключительный сервис и создавайте незабываемые впечатления для наших гостей.'
      },
      {
        title: 'Специалист технической поддержки',
        location: 'Сиэтл, WA',
        type: 'Полная занятость',
        description: 'Обслуживайте и решайте проблемы с оборудованием и системами кинотеатра.'
      },
      {
        title: 'Координатор мероприятий',
        location: 'Бостон, MA',
        type: 'Полная занятость',
        description: 'Планируйте и проводите специальные показы и частные мероприятия в кинотеатре.'
      }
    ],
    testimonials: [
      {
        name: 'Эмили Ричардсон',
        position: 'Менеджер кинотеатра',
        quote: 'Работа здесь была невероятным путешествием. Возможности роста и поддерживающая среда делают это гораздо больше, чем просто работа.'
      },
      {
        name: 'Майкл Андерсон',
        position: 'Старший киномеханик',
        quote: 'Технология и оборудование, с которым мы работаем, на высоте. Для любого любителя кино это мечта сбылась.'
      },
      {
        name: 'Сара Мартинес',
        position: 'Координатор мероприятий',
        quote: 'Команда здесь потрясающая. Мы работаем вместе, чтобы создать незабываемые впечатления для наших гостей.'
      }
    ],
    applicationSteps: [
      {
        title: 'Подать заявку онлайн',
        description: 'Отправьте заявку через наш карьерный портал.'
      },
      {
        title: 'Начальное рассмотрение',
        description: 'Наша команда рассмотрит вашу заявку в течение 48 часов.'
      },
      {
        title: 'Собеседование',
        description: 'Встретьтесь с нашей командой, чтобы обсудить возможность.'
      },
      {
        title: 'Добро пожаловать',
        description: 'Начните свое путешествие с нашей киносемьей.'
      }
    ]
  },
  companies: {
    searchPlaceholder: 'Поиск компаний...',
    location: 'Местонахождение',
    companySize: 'Размер компании',
    industry: 'Отрасль',
    openPositions: 'открытых вакансий',
    viewJobs: 'Просмотреть вакансии',
    loadMore: 'Загрузить больше компаний',
    companyList: [
      {
        name: 'Universal Entertainment Group',
        location: 'Лос-Анджелес, CA',
        size: '5,000+ сотрудников',
        description: 'Ведущая глобальная развлекательная компания, производящая и распространяющая кино- и телевизионный контент по всему миру.'
      },
      {
        name: 'Cinemark Productions',
        location: 'Нью-Йорк, NY',
        size: '2,000-5,000 сотрудников',
        description: 'Награжденная производственная студия, специализирующаяся на блокбастерах и инновационном цифровом контенте.'
      },
      {
        name: 'Digital Cinema Solutions',
        location: 'Сан-Франциско, CA',
        size: '1,000-2,000 сотрудников',
        description: 'Технологическая компания, революзирующая опыт цифрового кино через инновационные решения.'
      },
      {
        name: 'Paramount Digital Studios',
        location: 'Чикаго, IL',
        size: '500-1,000 сотрудников',
        description: 'Создаем цифровые развлекательные эксперименты следующего поколения через передовые технологии.'
      },
      {
        name: 'Global Theater Networks',
        location: 'Майами, FL',
        size: '1,000-2,000 сотрудников',
        description: 'Управление премиальными сетями кинотеатров с современными помещениями в крупных городах.'
      },
      {
        name: 'Silverscreen Technologies',
        location: 'Сиэтл, WA',
        size: '500-1,000 сотрудников',
        description: 'Разрабатываем передовые программные решения для современной киноиндустрии.'
      }
    ]
  },
  about: {
    heroTitle: 'О нас',
    heroSubtitle: 'Где творчество встречается с технологией, истории оживают через инновационные объективы.',
    ourStory: 'Наша история',
    storyParagraph1: 'CineMaster Studio был основан в 2010 году и уже более десяти лет находится на переднем крае кинематографических инноваций. Наше путешествие началось с простой, но мощной визии: создавать убедительные визуальные истории, которые находят отклик у аудитории по всему миру.',
    storyParagraph2: 'Сегодня мы гордимся тем, что являемся одной из ведущих производственных студий, сотрудничая с глобальными брендами и талантливыми художниками в отрасли. Наше стремление к совершенству и страсть к рассказыванию историй продолжают двигать нас вперед.',
    ourCoreValues: 'Наши основные ценности',
    creativeExcellence: 'Творческое превосходство',
    creativeExcellenceDesc: 'Расширяя границы и устанавливая новые стандарты в визуальном повествовании.',
    collaborativeSpirit: 'Дух сотрудничества',
    collaborativeSpiritDesc: 'Работая вместе, чтобы воплотить уникальные визии в жизнь.',
    qualityFirst: 'Качество превыше всего',
    qualityFirstDesc: 'Стремясь к совершенству в каждом созданном нами кадре.',
    meetOurTeam: 'Познакомьтесь с нашей командой',
    creativeDirector: 'Креативный директор',
    leadCinematographer: 'Старший оператор-постановщик',
    technicalDirector: 'Технический директор',
    productionManager: 'Менеджер производства',
    yearsExperience: 'лет опыта',
    projectsCompleted: 'проектов выполнено',
    industryAwards: 'индустрийных наград',
    happyClients: 'довольных клиентов'
  },
  footer: {
    copyright: '© 2025 TJH - Ticket Job Hub. Все права защищены.',
    description: 'Соединяя талант с возможностями в киноиндустрии. Найдите свою следующую роль в управлении кинотеатром, управлении или технических позициях.',
    quickLinks: 'Быстрые ссылки',
    jobSeeker: 'Соискателю',
    newsletter: 'Новостная рассылка',
    newsletterText: 'Подпишитесь, чтобы получать последние обновления вакансий и советы по карьере.',
    emailPlaceholder: 'Ваш email',
    subscribe: 'Подписаться',
    quickLinksList: ['О нас', 'Связаться с нами', 'Политика конфиденциальности', 'Условия обслуживания'],
    jobSeekerLinksList: ['Просмотреть вакансии', 'Карьерные ресурсы', 'Советы по резюме', 'Уведомления о вакансиях']
  }
}